// extracted by mini-css-extract-plugin
module.exports = {"root":"Saved_root__36OQh","fallbackText":"Saved_fallbackText__3J2Wf","link":"Saved_link__kdEhf"};